export const TimeUnit = {
  Day: 'day',
  Week: 'week',
  Month: 'month',
} as const;

export const JanitorKind = {
  Contractor: 'Contractor',
  Partner: 'Partner',
} as const;

export const MemberReservationLimitKind = {
  InTimeRange: 'InTimeRange',
  None: 'None',
} as const;

export const PriceInfo = {
  Free: 'Free',
  TaiwanPay: 'TaiwanPay',
  Point: 'Point',
  Both: 'Both',
} as const;

export const DataType = {
  Limit: 'Limit',
  Remaining: 'Remaining',
} as const;
